import { routes } from "../../../constants/routes";
export const breadcrumbLink = [
  {
    label: "User Management",
    link: "#",
    handleClick: () => {},
  },
  {
    label: "User List",
    link: routes.USER_MANAGEMENT_LIST,
    handleClick: () => {},
  },
];

export const userMngmtFilterOptions = [
  {
    label: "First Name",
    value: false,
  },
  {
    label: "Last Name",
    value: false,
  },
  {
    label: "Roles",
    value: false,
  },
  {
    label: "Date Added Range",
    value: false,
  },
  {
    label: "Status",
    value: false,
  },
  {
    label: "Company Name",
    value: false,
  },
  {
    label: "Email",
    value: false,
  },
];

export const getHeaders = () => {
  const userData = JSON.parse(localStorage.getItem("loginData") || "null");
  const isSuperTenant = userData?.tenantDetails?.tenantType === "SuperTenant";

  return [
    {
      key: "select",
      label: "",
    },
    ...(isSuperTenant
      ? [{ key: "company", label: "Company", isSortable: false }]
      : []),
    { key: "firstName", label: "First Name", isSortable: true },
    { key: "lastName", label: "Last Name", isSortable: true },
    { key: "phone", label: "Phone Number", isSortable: true },
    { key: "role", label: "Role", isSortable: true },
    { key: "email", label: "Email ID", isSortable: true },
    { key: "dateAdded", label: "Date Added", isSortable: true },
    { key: "status", label: "Status", isSortable: true },
  ];
};
